import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/config";

export const useActualVsExtendedBilling = () => {
  return useQuery({
    queryKey: ["original-vs-final-billing"],
    queryFn: async () => {
      const data = await api.get("original-vs-final-billing");
      return data.data.data;
    },
  });
};
